import Modal from '@components/modal/modal.component';
import { AlertBadge } from '@components/alert-badge/alert-badge';

import styles from './delete-plan-modal.module.scss';

type Props = {
    loading: boolean;
    onConfirm: () => void;
    onDiscard: () => void;
};

const DeletePlanModal = ({ loading, onConfirm, onDiscard }: Props) => (
    <Modal onConfirm={onConfirm} onDiscard={onDiscard} confirmLoading={loading}>
        <div className={styles.modalContent}>
            <h4>Eliminar plan</h4>
            <AlertBadge type="warning" text="Acción peligrosa" />
            <span className={styles.bodyText}>
                ¿Estás seguro que deseas eliminar este plan? Una vez que se
                elimine, no podrás recuperarlo.
            </span>
        </div>
    </Modal>
);

export { DeletePlanModal };
